export const CMSConstants = {
   
    GETALL_REQUEST: 'CMS_PAGES_GETALL_REQUEST',
    GETALL_SUCCESS: 'CMS_PAGES_GETALL_SUCCESS',
    GETALL_FAILURE: 'CMS_PAGES_GETALL_FAILURE',
};
